// Configuration loaded from environment variables (injected by webpack)
const config = {
    // API Configuration
    API_URL: process.env.API_URL || "http://localhost:8080",
    // Auth0 Configuration
    AUTH0_DOMAIN: process.env.AUTH0_DOMAIN || "",
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID || "",
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE || "",
};
export default config;
